export const FETCH_OVERVIEW_DATA = 'FETCH_OVERVIEW_DATA';
export const FETCH_PAGE_VIEWS_DATA = 'FETCH_PAGE_VIEWS_DATA';
export const FETCH_SESSIONS_DATA = 'FETCH_SESSIONS_DATA';
export const FETCH_TIME_ON_SITE_DATA = 'FETCH_TIME_ON_SITE_DATA';
export const FETCH_UNIQUE_VISITS_DATA = 'FETCH_UNIQUE_VISITS_DATA';
